<div class="ag-large-text-input ag-labeled ag-label-align-left ag-text-area ag-input-field">
  <div class="ag-wrapper ag-input-wrapper ag-text-area-input-wrapper">
    <textarea #inputTextArea [formControl]="control" matInput
    class="ag-input-field-input ag-text-area-input fullsize-textarea" cols="60" rows="10"></textarea>
  </div>

  @if (control.invalid) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon" [matTooltip]="errorTooltip"></mat-icon>
    </div>
  }
  <div>
    <mat-icon fontSet="mdi" fontIcon="mdi-check" (click)="stopEditing()"></mat-icon>
  </div>
</div>

